import { AiIcon } from '../../icons';

export const BotIcon = () => {
  return (
    <span style={{ position: 'relative', top: 3, left: 3 }}>
      <AiIcon width={18} height={18} />
    </span>
  );
};
